"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _constant = require("./constant");

var _Popover = _interopRequireDefault(require("./Popover.proptypes"));

var _excluded = ["id"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledPopoverContainer = _styledComponents.default.div.withConfig({
  displayName: "Popover__StyledPopoverContainer",
  componentId: "sc-ck78hy-0"
})(["z-index:", ";", ""], function (_ref) {
  var zIndex = _ref.zIndex;
  return zIndex;
}, function (_ref2) {
  var asToolTip = _ref2.asToolTip,
      childWidth = _ref2.childWidth;
  return !asToolTip ? (0, _styledComponents.css)(["position:relative;width:auto;display:inline-flex;width:100%;"]) : (0, _styledComponents.css)(["display:flex;flex-flow:row wrap;width:", ";"], childWidth);
});

var StyledPopover = _styledComponents.default.div.withConfig({
  displayName: "Popover__StyledPopover",
  componentId: "sc-ck78hy-1"
})(["background:", ";border-radius:", ";box-shadow:0px 1px 4px rgba(0,0,0,0.16);position:absolute;padding:", ";z-index:", ";width:", ";opacity:", ";margin-left:", ";padding:", ";&:hover{backgroud:", ";}", ""], function (_ref3) {
  var theme = _ref3.theme,
      background = _ref3.background;
  return background || theme.backgroundColor.default;
}, function (_ref4) {
  var borderRadius = _ref4.borderRadius;
  return borderRadius ? "".concat(borderRadius, "px") : '0';
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.space.tiny, " ").concat(theme.space.XSmall);
}, function (_ref6) {
  var zIndex = _ref6.zIndex;
  return zIndex;
}, function (_ref7) {
  var width = _ref7.width;
  return "".concat(width, "px");
}, function (_ref8) {
  var show = _ref8.show;
  return show ? '1' : '0';
}, function (_ref9) {
  var marginLeft = _ref9.marginLeft;
  return marginLeft || 'auto';
}, function (props) {
  return props.padding;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.backgroundColor.primary;
}, function (_ref11) {
  var position = _ref11.position,
      width = _ref11.width,
      top = _ref11.top,
      left = _ref11.left,
      bottom = _ref11.bottom,
      right = _ref11.right;

  switch (position) {
    case 'right':
      return "right:-".concat(width + 40, "px;top:0px;");

    case 'left':
      return "left:-".concat(width + 40, "px;top:0px;");

    case 'top':
      return "left:".concat(left || "-".concat(width / 2 * 0.25, "px"), ";top: ").concat(top || '-50px', ";bottom: ").concat(bottom || 'inherit', ";right: ").concat(right || 'auto');

    case 'bottom':
      return "left:-".concat(width / 2 * 0.06, "px;bottom:-50px;");

    /* istanbul ignore next */

    default:
      return '';
  }
});

var StyledPopoverArrow = _styledComponents.default.div.withConfig({
  displayName: "Popover__StyledPopoverArrow",
  componentId: "sc-ck78hy-2"
})(["position:absolute;display:block;width:1rem;height:0.5rem;margin:0 0.3rem;", " width:13.56px;height:13.56px;margin:0.3rem 0;&:before,&:after{position:absolute;display:block;content:'';border-color:transparent;border-style:solid;}&:before{", "}&:after{", "}"], function (_ref12) {
  var position = _ref12.position,
      width = _ref12.width,
      rightArrow = _ref12.rightArrow,
      leftArrow = _ref12.leftArrow;

  switch (position) {
    case 'right':
      return "left: calc((0.5rem + 1px) * -1); top: 0;";

    case 'left':
      return "right: calc((0.5rem + 1px) * -1); top: 0;";

    case 'top':
      return "bottom: calc((.5rem + 1px) * -1);left:".concat(rightArrow ? 'auto' : "".concat(leftArrow || Math.ceil(width / 2 + 5), "px"), ";right: ").concat(rightArrow || 'auto', ";");

    case 'bottom':
      return "top: calc((.5rem + 1px) * -1);left:".concat(Math.ceil(width / 2 + 5), "px;");

    /* istanbul ignore next */

    default:
      return '';
  }
}, function (_ref13) {
  var position = _ref13.position,
      theme = _ref13.theme;

  switch (position) {
    case 'right':
      return "left: -1px; border-width:  ".concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.tiny, " 0;\n          border-right-color: rgba(0, 0, 0, 0.05);");

    case 'left':
      return "right: -1px; border-width:  0.5rem 0 ".concat(theme.space.tiny, " ").concat(theme.space.tiny, ";\n          border-left-color: rgba(0, 0, 0, 0.05);");

    case 'top':
      return "bottom: -5px;border-width: ".concat(theme.space.tiny, " ").concat(theme.space.tiny, " 0;\n          border-top-color: rgba(0, 0, 0, 0.05);");

    case 'bottom':
      return "top: -5px;border-width: 0 ".concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.tiny, ";\n          border-bottom-color: rgba(0, 0, 0, 0.05);");

    /* istanbul ignore next */

    default:
      return '';
  }
}, function (_ref14) {
  var position = _ref14.position,
      theme = _ref14.theme,
      background = _ref14.background;

  switch (position) {
    case 'right':
      return "left: 1px;border-width:\n            ".concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.tiny, " 0;\n            border-right-color: ").concat(background || theme.colors.default, ";");

    case 'left':
      return "right: 1px;  border-width: ".concat(theme.space.tiny, " 0\n            ").concat(theme.space.tiny, " ").concat(theme.space.tiny, ";\n            border-left-color: ").concat(background || theme.colors.default, ";");

    case 'top':
      return "bottom: -3px;border-width:".concat(theme.space.tiny, " ").concat(theme.space.tiny, " 0;\n          border-top-color: ").concat(background || theme.colors.default, ";");

    case 'bottom':
      return "top: -3px;border-width: 0 ".concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.tiny, ";\n          border-bottom-color: ").concat(background || theme.colors.default, ";");

    /* istanbul ignore next */

    default:
      return '';
  }
});

var StyledPopoverHeader = _styledComponents.default.div.withConfig({
  displayName: "Popover__StyledPopoverHeader",
  componentId: "sc-ck78hy-3"
})([""]);

var StyledPopoverBody = _styledComponents.default.div.withConfig({
  displayName: "Popover__StyledPopoverBody",
  componentId: "sc-ck78hy-4"
})(["color:#212529;width:", "px;"], function (_ref15) {
  var width = _ref15.width;
  return width;
});

var ContentContainer = _styledComponents.default.div.withConfig({
  displayName: "Popover__ContentContainer",
  componentId: "sc-ck78hy-5"
})(["padding:", ";width:", "px;background-color:", ";position:absolute;border-radius:", ";", " ", " ", " &::before{content:' ';border:solid transparent;position:absolute;border-width:", ";", " ", " ", "}filter:drop-shadow(0px 4px 8px rgba(0,0,0,0.12));"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.space.small;
}, function (_ref17) {
  var width = _ref17.width;
  return width;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.default;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.micro;
}, function (_ref20) {
  var position = _ref20.position,
      theme = _ref20.theme;
  return position === _constant.CONTENT_POSITION.RIGHT && (0, _styledComponents.css)(["transform:translateY(-50%) translateX(", ");"], function () {
    return theme.space.XSmall;
  });
}, function (_ref21) {
  var position = _ref21.position,
      theme = _ref21.theme;
  return position === _constant.CONTENT_POSITION.TOP && (0, _styledComponents.css)(["transform:translateY(calc(-100% - ", ")) translateX(-50%);"], function () {
    return theme.space.XSmall;
  });
}, function (_ref22) {
  var position = _ref22.position,
      theme = _ref22.theme;
  return position === _constant.CONTENT_POSITION.BOTTOM && (0, _styledComponents.css)(["transform:translateY(calc(", ")) translateX(-50%);"], theme.space.semi);
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.space.XXXSmall;
}, function (_ref24) {
  var position = _ref24.position,
      theme = _ref24.theme;
  return position === _constant.CONTENT_POSITION.RIGHT && (0, _styledComponents.css)(["left:-", ";top:50%;border-right-color:", ";"], function () {
    return theme.space.normal;
  }, function () {
    return theme.colors.default;
  });
}, function (_ref25) {
  var position = _ref25.position,
      theme = _ref25.theme;
  return position === _constant.CONTENT_POSITION.TOP && (0, _styledComponents.css)(["right:50%;top:100%;border-top-color:", ";"], function () {
    return theme.colors.default;
  });
}, function (_ref26) {
  var position = _ref26.position,
      theme = _ref26.theme;
  return position === _constant.CONTENT_POSITION.BOTTOM && (0, _styledComponents.css)(["right:50%;top:-", ";border-bottom-color:", ";"], function () {
    return theme.space.normal;
  }, function () {
    return theme.colors.default;
  });
});

var Popover = function Popover(_ref27) {
  var accessible = _ref27.accessible,
      theme = _ref27.theme,
      customProperties = _ref27.customProperties,
      children = _ref27.children,
      position = _ref27.position,
      width = _ref27.width,
      content = _ref27.content,
      header = _ref27.header,
      trigger = _ref27.trigger,
      open = _ref27.open,
      zIndex = _ref27.zIndex,
      background = _ref27.background,
      borderRadius = _ref27.borderRadius,
      left = _ref27.left,
      marginLeft = _ref27.marginLeft,
      top = _ref27.top,
      bottom = _ref27.bottom,
      asToolTip = _ref27.asToolTip,
      childWidth = _ref27.childWidth,
      outsideClck = _ref27.outsideClck,
      right = _ref27.right,
      rightArrow = _ref27.rightArrow,
      padding = _ref27.padding,
      leftArrow = _ref27.leftArrow;
  var customId = customProperties.id,
      customProps = (0, _objectWithoutProperties2.default)(customProperties, _excluded);

  var _React$useState = _react.default.useState(open || false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var id = customId || "popover-".concat(Math.random());
  var headerIsString = typeof header === 'string';
  var contentIsString = typeof content === 'string';
  (0, _react.useEffect)(function () {
    if (outsideClck) {
      window.addEventListener('click', function (_ref28) {
        var target = _ref28.target;

        if (isOpen && target.id !== 'toolTipId') {
          setIsOpen(!isOpen);
        }
      }, true);
    }
  }, [isOpen, outsideClck]);

  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      setTimeout(function () {
        if (trigger === _constant.TRIGGERS.focus) {
          document.querySelector("#".concat(id, " input")).addEventListener('focus', function () {
            setIsOpen(true);
          });
          document.querySelector("#".concat(id, " input")).addEventListener('blur', function () {
            setIsOpen(false);
          });
        }
      }, 0);
    }

    return function () {
      if (typeof window !== 'undefined') {
        setTimeout(function () {
          if (trigger === _constant.TRIGGERS.focus && document.querySelector('#'.concat(id, ' input')) !== null) {
            document.querySelector("#".concat(id, " input")).removeEventListener('focus', function () {});
            document.querySelector("#".concat(id, " input")).removeEventListener('blur', function () {});
          }
        }, 0);
      }
    };
  }, [trigger, id]);

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledPopoverContainer, (0, _extends2.default)({
    zIndex: zIndex,
    id: id,
    asToolTip: asToolTip,
    childWidth: childWidth
  }, trigger === _constant.TRIGGERS.hover ? {
    onMouseEnter: function onMouseEnter() {
      return setIsOpen(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsOpen(false);
    }
  } : {}, trigger === _constant.TRIGGERS.click ? {
    onClickCapture: function onClickCapture() {
      return setIsOpen(!isOpen);
    }
  } : {}, {
    // {...(trigger === TRIGGERS.focus
    //   ? {
    //       onFocus: () => setIsOpen(!isOpen),
    //     }
    //   : {})}
    width: width,
    tabIndex: !accessible ? '-1' : '0'
  }, customProps), children, asToolTip && /*#__PURE__*/_react.default.createElement(StyledPopoverHeader, null, isOpen && /*#__PURE__*/_react.default.createElement(ContentContainer, {
    width: width,
    position: position
  }, content)), isOpen && !asToolTip && /*#__PURE__*/_react.default.createElement(StyledPopover, {
    show: isOpen,
    position: position,
    width: width,
    zIndex: zIndex,
    background: background,
    borderRadius: borderRadius,
    left: left,
    top: top,
    marginLeft: marginLeft,
    bottom: bottom,
    right: right,
    padding: padding
  }, /*#__PURE__*/_react.default.createElement(StyledPopoverArrow, {
    position: position,
    width: width,
    background: background,
    rightArrow: rightArrow,
    leftArrow: leftArrow
  }), header && /*#__PURE__*/_react.default.createElement(StyledPopoverHeader, null, headerIsString ? /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant.TEXT_PROPS.display,
    theme: theme,
    type: _constant.TEXT_PROPS.type
  }, header) : header), /*#__PURE__*/_react.default.createElement(StyledPopoverBody, {
    width: width
  }, contentIsString ? /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant.TEXT_PROPS.display,
    theme: theme,
    type: _constant.TEXT_PROPS.type
  }, content) : content))));
};

Popover.propTypes = _Popover.default.PropTypes;
Popover.defaultProps = _Popover.default.DefaultProps;
var _default = Popover;
exports.default = _default;